(function () {
  'use strict';

  // ---- Configuración ----
  var PRODUCTS = {};
  var PRODUCTS_BY_HANDLE = {};
  try {
    var pEl = document.getElementById('calc-products');
    if (pEl) PRODUCTS = JSON.parse(pEl.textContent || '{}');
    Object.keys(PRODUCTS).forEach(function (k) {
      var pr = PRODUCTS[k];
      if (pr && pr.handle) PRODUCTS_BY_HANDLE[pr.handle] = pr;
    });
  } catch (e) {
    PRODUCTS = {};
  }
  // Busca un producto por título o por handle (store-agnostic)
  function findProduct(key) {
    if (!key) return null;
    return PRODUCTS[key] || PRODUCTS_BY_HANDLE[key] || null;
  }

  var RAZAS = [
    'Labrador', 'Golden Retriever', 'Pastor Alemán', 'Bulldog', 'Poodle',
    'Rottweiler', 'Beagle', 'Chihuahua', 'Husky Siberiano', 'Border Collie',
    'Cocker Spaniel', 'Mestizo', 'Otra'
  ];
  var RAZAS_ACTIVAS = ['Border Collie', 'Cocker Spaniel', 'Labrador', 'Golden Retriever', 'Pastor Alemán', 'Husky Siberiano'];

  var BREED_WEIGHTS = {
    'Labrador': 30, 'Golden Retriever': 30, 'Pastor Alemán': 35, 'Bulldog': 25,
    'Poodle': 20, 'Rottweiler': 40, 'Beagle': 12, 'Chihuahua': 3,
    'Husky Siberiano': 25, 'Border Collie': 20, 'Cocker Spaniel': 14,
    'Mestizo': 22, 'Otra': 22
  };
  var BREED_RECOMMENDED = {
    'Labrador': 28, 'Golden Retriever': 28, 'Pastor Alemán': 32, 'Bulldog': 22,
    'Poodle': 18, 'Rottweiler': 38, 'Beagle': 11, 'Chihuahua': 3,
    'Husky Siberiano': 23, 'Border Collie': 18, 'Cocker Spaniel': 13,
    'Mestizo': 20, 'Otra': 20
  };

  var STORAGE_KEY = 'carnivoro_calc';

  // ---- Estado ----
  var state = {
    recipe: null,
    result: null,
    showResult: false,
    showQuantity: false,
    cartQty: 1,
    showWeekly: false,
    weeklyQty: 1,
    embedded: false,
    embeddedProduct: null
  };

  var forms = {
    bawfy: loadForm('bawfy', { nombre: '', edad: 0, peso: 0, estado: 'sano', raza: '' }),
    natural: loadForm('natural', { nombre: '', edad: 0, peso: 0, estado: 'sano', raza: '', actividad: 'normal' }),
    crecimiento: loadForm('crecimiento', { nombre: '', pesoActual: 0, pesoEsperado: 0, raza: '', tipoRaza: 'normal' }),
    equilibrio: loadForm('equilibrio', { nombre: '', peso: 0, pesoRecomendado: 0, raza: '' })
  };

  // ---- Utilidades ----
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function loadForm(recipe, def) {
    try {
      var data = localStorage.getItem(STORAGE_KEY + '_' + recipe);
      if (data) return Object.assign({}, def, JSON.parse(data));
    } catch (e) {}
    return def;
  }
  function saveForm(recipe) {
    try {
      localStorage.setItem(STORAGE_KEY + '_' + recipe, JSON.stringify(forms[recipe]));
    } catch (e) {}
  }

  function isRazaActiva(raza) { return RAZAS_ACTIVAS.indexOf(raza) !== -1; }

  function estimateExpectedWeight(raza, pesoActual) {
    return BREED_WEIGHTS[raza] || Math.round(pesoActual * 1.3);
  }
  function estimateRecommendedWeight(raza, peso) {
    return BREED_RECOMMENDED[raza] || Math.round(peso * 0.85);
  }

  // ---- Lógica de cálculo (replica CalculatorService) ----
  function getActivityFactor(level) {
    if (level === 'sedentario') return 70;
    if (level === 'activo') return 100;
    return 87;
  }
  function getBasePortion(peso, estado) {
    if (estado === 'cachorro') return peso * 40;
    if (estado === 'obeso') return peso * 20;
    return peso * 30;
  }
  function getAgeMultiplier(edad, estado) {
    if (estado === 'cachorro') {
      if (edad <= 3) return 1.2;
      if (edad <= 6) return 1.0;
      return 0.9;
    }
    if (estado === 'obeso') return 0.8;
    if (edad > 8) return 0.85;
    if (edad > 5) return 0.95;
    return 1.0;
  }
  function getRecommendedBawfyProduct(form) {
    if (form.estado === 'cachorro') return 'Bawfy Barf Pollo 500g';
    if (form.estado === 'obeso') return 'Bawfy Barf Res 500gr';
    if (form.peso > 20) return 'Bawfy Barf Res 500gr';
    return 'Bawfy Barf Pollo 500g';
  }

  function calculate(recipe) {
    var f = forms[recipe];
    var res;
    if (recipe === 'natural') {
      var kcalPerKg = 1207, factor = getActivityFactor(f.actividad), peso = f.peso;
      var kcal = Math.pow(peso, 0.75) * factor;
      var gramos = Math.round((kcal / kcalPerKg) * 1000);
      res = {
        porcionDiaria: gramos,
        porcionComida: Math.round(gramos / 2),
        comidasPorDia: 2,
        productoRecomendado: 'carnivoro-natural',
        kcalDiarias: Math.round(kcal),
        pesoReferencia: peso
      };
    } else if (recipe === 'crecimiento') {
      var kc = 1037, fac = 130, p = f.pesoActual, pe = f.pesoEsperado;
      var kcalC = fac * Math.pow(p, 0.75) * 3.2 * (Math.exp(-0.87 * (p / pe)) - 0.1);
      var gC = Math.round((kcalC / kc) * 1000);
      res = {
        porcionDiaria: gC,
        porcionComida: Math.round(gC / 3),
        comidasPorDia: 3,
        productoRecomendado: 'Carnivoro Crecimiento Salvaje 500g',
        kcalDiarias: Math.round(kcalC),
        pesoReferencia: pe
      };
    } else if (recipe === 'equilibrio') {
      var kq = 800, fq = 70, pw = f.pesoRecomendado;
      var kcalE = Math.pow(pw, 0.75) * fq;
      var gE = Math.round((kcalE / kq) * 1000);
      res = {
        porcionDiaria: gE,
        porcionComida: Math.round(gE / 2),
        comidasPorDia: 2,
        productoRecomendado: 'Carnivoro Equilibrio Salvaje 500g',
        kcalDiarias: Math.round(kcalE),
        pesoReferencia: pw
      };
    } else {
      var base = getBasePortion(f.peso, f.estado);
      var mult = getAgeMultiplier(f.edad, f.estado);
      var pDiaria = Math.round(base * mult);
      var comidas = f.estado === 'cachorro' ? 3 : 2;
      // En el detalle de producto, la recomendación es el producto que se está viendo.
      // En la landing se mantiene el modelo de recomendación por estado/peso.
      var productoRecomendado = (state.embedded && state.embeddedProduct)
        ? state.embeddedProduct
        : getRecommendedBawfyProduct(f);
      res = {
        porcionDiaria: pDiaria,
        porcionComida: Math.round(pDiaria / comidas),
        comidasPorDia: comidas,
        productoRecomendado: productoRecomendado
      };
    }
    return res;
  }

  function weeklyRecommendation(res) {
    if (!res) return null;
    var weeklyGrams = res.porcionDiaria * 7;
    var pkg = 500;
    var packagesNeeded = Math.ceil(weeklyGrams / pkg);
    var product = findProduct(res.productoRecomendado);
    var unitPrice = product ? product.price : 0;
    return {
      weeklyFoodGrams: weeklyGrams,
      packagesNeeded: packagesNeeded,
      unitPrice: unitPrice,
      totalCost: packagesNeeded * unitPrice
    };
  }

  function cop(n) {
    return '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  // ---- Render ----
  var root;

  function render() {
    if (state.showResult) return renderResult();
    if (state.recipe) return renderForm();
    return renderSelector();
  }

  function renderSelector() {
    root.innerHTML =
      '<h2>Calcula tu porción</h2>' +
      '<p class="section-subtitle">Selecciona el producto para calcular la porción ideal</p>' +
      '<div class="recipe-selector">' +
        recipeCard('natural', '🥩', 'Carnívoro Natural', 'Receta Natural para perros adultos', '1207 Kcal/kg') +
        recipeCard('crecimiento', '🐾', 'Crecimiento Salvaje', 'Receta para cachorros en crecimiento', '1037 Kcal/kg') +
        recipeCard('equilibrio', '⚖️', 'Equilibrio Salvaje', 'Receta para control de peso', '800 Kcal/kg') +
        recipeCard('bawfy', '🍖', 'BAWFY', 'Pollo y Res', 'Estándar', true) +
      '</div>';
  }

  function recipeCard(recipe, icon, title, desc, badge, secondary) {
    return '<button type="button" class="recipe-card' + (secondary ? ' recipe-card-secondary' : '') + '" data-recipe="' + recipe + '">' +
      '<span class="recipe-icon">' + icon + '</span>' +
      '<h3>' + title + '</h3>' +
      '<p>' + desc + '</p>' +
      '<span class="recipe-badge">' + badge + '</span>' +
      '</button>';
  }

  function renderForm() {
    var recipe = state.recipe;
    var f = forms[recipe];
    var html = '';
    if (!state.embedded) {
      html += '<button type="button" class="back-btn">← Volver a selección</button>';
    }

    if (recipe === 'natural') {
      html += '<h2>Carnívoro Natural</h2><p class="section-subtitle">Receta Natural — 1207 Kcal/kg</p>';
      html += formOpen();
      html += field('text', 'nombre', 'Nombre de tu mascota', f.nombre, 'Ej: Max');
      html += formRow(
        field('number', 'peso', 'Peso (kg)', f.peso, 'Ej: 25', 'min="1" max="100" step="0.1"'),
        razaField(f.raza)
      );
      html += radioGroup('actividad', [
        ['sedentario', 'Sedentario (Factor: 70)'],
        ['normal', 'Normal (Factor: 80-95)'],
        ['activo', 'Activo (Factor: 95-110)']
      ], f.actividad);
      html += infoBox('<strong>Factor energético:</strong> Sedentario (70) — Normal (80-95) — Activo (95-110)', 'Solo modificamos peso y nivel de actividad');
    } else     if (recipe === 'crecimiento') {
      html += formOpen();
      html += field('text', 'nombre', 'Nombre de tu mascota', f.nombre, 'Ej: Max');
      html += formRow(
        field('number', 'pesoActual', 'Peso actual (kg)', f.pesoActual, 'Ej: 6', 'min="1" max="50" step="0.1"'),
        field('number', 'pesoEsperado', 'Peso esperado a 12 meses (kg)', f.pesoEsperado, 'Ej: 25', 'min="1" max="80" step="0.1"')
      );
      html += razaField(f.raza);
      html += infoBox('<strong>Factor energético fijo:</strong> 130 (razas activas) — 110 (demás razas)', 'Se modifica peso actual, peso esperado y raza');
    } else if (recipe === 'equilibrio') {
      html += '<h2>Equilibrio Salvaje</h2><p class="section-subtitle">Receta Equilibrio — 800 Kcal/kg</p>';
      html += formOpen();
      html += field('text', 'nombre', 'Nombre de tu mascota', f.nombre, 'Ej: Max');
      html += formRow(
        field('number', 'peso', 'Peso actual (kg)', f.peso, 'Ej: 30', 'min="1" max="100" step="0.1"'),
        field('number', 'pesoRecomendado', 'Peso recomendado (kg)', f.pesoRecomendado, 'Ej: 25', 'min="1" max="100" step="0.1"')
      );
      html += razaField(f.raza);
      html += infoBox('<strong>Factor energético:</strong> 130 (según recomendación profesional)', 'Se calcula según el peso recomendado por el profesional');
    } else {
      html += '<h2>Calcula tu porción BAWFY</h2><p class="section-subtitle">Alimento estándar — Pollo y Res</p>';
      html += formOpen();
      html += field('text', 'nombre', 'Nombre de tu mascota', f.nombre, 'Ej: Max');
      html += formRow(
        field('number', 'edad', 'Edad (meses)', f.edad, 'Ej: 12', 'min="1" max="200"'),
        field('number', 'peso', 'Peso (kg)', f.peso, 'Ej: 25', 'min="1" max="100" step="0.1"')
      );
      html += radioGroup('estado', [
        ['sano', 'Sano'],
        ['obeso', 'Obeso'],
        ['cachorro', 'Cachorro']
      ], f.estado);
      html += razaField(f.raza);
    }

    html += '<button type="button" class="btn btn-primary btn-block btn-calc" ' + (isFormValid() ? '' : 'disabled') + '>Calcular porción</button>';
    html += '</div>';

    root.innerHTML = html;

    // Enlazar inputs
    $all('input, select', root).forEach(function (el) {
      el.addEventListener('input', function () { onFieldChange(recipe, el); });
      el.addEventListener('change', function () { onFieldChange(recipe, el); });
    });
  }

  function onFieldChange(recipe, el) {
    var name = el.getAttribute('name');
    var val = el.value;
    if (el.type === 'number') val = parseFloat(val) || 0;
    forms[recipe][name] = val;

    if (recipe === 'crecimiento' && name === 'raza') {
      forms.crecimiento.tipoRaza = isRazaActiva(val) ? 'activo' : 'normal';
    }
    // Habilitar/deshabilitar botón
    var btn = $('.btn-calc', root);
    if (btn) btn.disabled = !isFormValid();
  }

  function renderResult() {
    var res = state.result;
    var weekly = weeklyRecommendation(res);
    var product = findProduct(res.productoRecomendado);
    var productName = (product && product.title) ? product.title : res.productoRecomendado;
    var html = '<button type="button" class="back-btn">← Calcular otra vez</button>';
    html += '<div class="result-card">';
    html += '<div class="result-header"><h3>¡Hola ' + (getNombreMascota()) + '! 🐾</h3><p>Esta es su porción recomendada:</p></div>';
    html += '<div class="result-stats">' +
      stat(res.porcionDiaria + 'g', 'Porción diaria') +
      stat(res.porcionComida + 'g', 'Por comida') +
      stat(res.comidasPorDia, 'Comidas al día') +
      '</div>';
    if (res.kcalDiarias) {
      html += '<div class="result-kcal"><span class="kcal-value">' + res.kcalDiarias + ' Kcal/día</span></div>';
    }
    html += '<div class="result-product"><p>Producto recomendado:</p>' +
      '<div class="result-product-content">' +
       '<img class="result-product-image" src="' + (product && product.image ? product.image : '') + '" alt="' + productName + '">' +
       '<h4>' + productName + '</h4></div></div>';

    if (weekly) {
      html += '<div class="weekly-recommendation"><h4>Recomendación semanal</h4>' +
        '<div class="weekly-stats">' +
        weeklyStat(weekly.weeklyFoodGrams + 'g', 'Alimento/semana') +
        weeklyStat(weekly.packagesNeeded, 'Paquetes de 500g') +
        weeklyStat(cop(weekly.totalCost), 'Costo estimado') +
        '</div>';
      if (!state.showWeekly) {
        html += '<div class="weekly-action"><button type="button" class="btn btn-primary btn-weekly" id="weekly-add">' +
          'Agregar ' + weekly.packagesNeeded + ' paquete(s) al carrito</button></div>';
      } else {
        html += '<div class="weekly-quantity-selector"><p class="weekly-qty-label">Cantidad de paquetes:</p>' +
          '<div class="weekly-qty-controls">' +
          '<button type="button" class="qty-btn" id="wk-minus">-</button>' +
          '<span class="qty-value">' + state.weeklyQty + '</span>' +
          '<button type="button" class="qty-btn" id="wk-plus">+</button></div>' +
          '<div class="weekly-qty-actions">' +
          '<button type="button" class="btn-confirm" id="wk-confirm">Confirmar (' + state.weeklyQty + ')</button>' +
          '<button type="button" class="btn-cancel" id="wk-cancel">Cancelar</button></div></div>';
      }
      html += '</div>';
    }

    if (!state.showQuantity) {
      html += '<div class="result-actions"><button type="button" class="btn btn-primary" id="add-cart">Agregar al carrito</button>' +
        '<button type="button" class="btn btn-secondary" id="again">Calcular otra vez</button></div>';
    } else {
      html += '<div class="result-actions"><div class="quantity-selector"><div class="quantity-controls">' +
        '<button type="button" class="qty-btn" id="q-minus">-</button>' +
        '<span class="qty-value">' + state.cartQty + '</span>' +
        '<button type="button" class="qty-btn" id="q-plus">+</button></div>' +
        '<button type="button" class="btn-confirm" id="q-confirm">Confirmar (' + state.cartQty + ')</button>' +
        '<button type="button" class="btn-cancel" id="q-cancel">Cancelar</button></div>' +
        '<button type="button" class="btn btn-secondary" id="again2">Calcular otra vez</button></div>';
    }
    html += '</div>';
    root.innerHTML = html;
  }

  // ---- Helpers de HTML ----
  function formOpen() { return '<div class="calculator-form">'; }
  function field(type, name, label, value, placeholder, extra) {
    return '<div class="form-group"><label for="' + name + '">' + label + '</label>' +
      '<input type="' + type + '" id="' + name + '" name="' + name + '" value="' + (value || '') + '" placeholder="' + (placeholder || '') + '" ' + (extra || '') + ' required></div>';
  }
  function formRow(a, b) { return '<div class="form-row">' + a + b + '</div>'; }
  function razaField(val) {
    var opts = '<option value="" disabled>Selecciona una raza</option>';
    RAZAS.forEach(function (r) {
      opts += '<option value="' + r + '"' + (r === val ? ' selected' : '') + '>' + r + '</option>';
    });
    return '<div class="form-group"><label for="raza">Raza</label><select id="raza" name="raza" required>' + opts + '</select></div>';
  }
  function radioGroup(name, items, current) {
    var html = '<div class="form-group"><label>' + (name === 'actividad' ? 'Nivel de actividad' : 'Estado') + '</label><div class="radio-group">';
    items.forEach(function (it) {
      html += '<label class="radio-label"><input type="radio" name="' + name + '" value="' + it[0] + '"' + (it[0] === current ? ' checked' : '') + '><span class="radio-custom"></span>' + it[1] + '</label>';
    });
    return html + '</div></div>';
  }
  function infoBox(p1, p2) {
    return '<div class="form-info"><p>' + p1 + '</p><p class="form-note">' + p2 + '</p></div>';
  }
  function stat(value, label) {
    return '<div class="stat"><span class="stat-value">' + value + '</span><span class="stat-label">' + label + '</span></div>';
  }
  function weeklyStat(value, label) {
    return '<div class="weekly-stat"><span class="weekly-stat-value">' + value + '</span><span class="weekly-stat-label">' + label + '</span></div>';
  }

  // ---- Acciones ----
  function selectRecipe(recipe) {
    state.recipe = recipe;
    state.showResult = false;
    state.result = null;
    state.showQuantity = false;
    state.showWeekly = false;
    autoPopulate(recipe);
    render();
  }
  function goBack() {
    if (state.embedded) return;
    state.recipe = null;
    state.showResult = false;
    state.result = null;
    state.showQuantity = false;
    state.showWeekly = false;
    render();
  }
  function calcular() {
    console.log('Calculando porción para receta:', state.recipe, forms[state.recipe]);
    if (!isFormValid()) return;
    state.result = calculate(state.recipe);
    state.showResult = true;
    state.showQuantity = false;
    state.showWeekly = false;
    state.cartQty = 1;
    saveForm(state.recipe);
    render();
  }
  function isFormValid() {
    var r = state.recipe, f = forms[r];
    if (r === 'natural') return f.nombre.trim() !== '' && f.peso > 0 && f.raza !== '';
    if (r === 'crecimiento') return f.nombre.trim() !== '' && f.pesoActual > 0 && f.pesoEsperado > 0 && f.raza !== '';
    if (r === 'equilibrio') return f.nombre.trim() !== '' && f.peso > 0 && f.pesoRecomendado > 0 && f.raza !== '';
    return f.nombre.trim() !== '' && f.edad > 0 && f.peso > 0 && f.raza !== '';
  }
  function getNombreMascota() {
    var r = state.recipe, f = forms[r];
    return f.nombre || '';
  }
  function autoPopulate(target) {
    var src = getAnyForm();
    if (!src) return;
    if (target === 'natural' && isEmpty('natural')) {
      forms.natural.nombre = src.nombre; forms.natural.peso = src.peso; forms.natural.raza = src.raza; forms.natural.actividad = 'normal';
    } else if (target === 'crecimiento' && isEmpty('crecimiento')) {
      forms.crecimiento.nombre = src.nombre; forms.crecimiento.pesoActual = src.peso;
      forms.crecimiento.pesoEsperado = estimateExpectedWeight(src.raza, src.peso);
      forms.crecimiento.raza = src.raza;
      forms.crecimiento.tipoRaza = isRazaActiva(src.raza) ? 'activo' : 'normal';
    } else if (target === 'equilibrio' && isEmpty('equilibrio')) {
      forms.equilibrio.nombre = src.nombre; forms.equilibrio.peso = src.peso;
      forms.equilibrio.pesoRecomendado = estimateRecommendedWeight(src.raza, src.peso);
      forms.equilibrio.raza = src.raza;
    } else if (target === 'bawfy' && isEmpty('bawfy')) {
      forms.bawfy.nombre = src.nombre; forms.bawfy.peso = src.peso; forms.bawfy.raza = src.raza;
      forms.bawfy.edad = src.edad || 12; forms.bawfy.estado = 'sano';
    }
  }
  function isEmpty(r) {
    var f = forms[r];
    if (r === 'bawfy') return f.nombre.trim() === '' || f.peso === 0;
    if (r === 'natural') return f.nombre.trim() === '' || f.peso === 0;
    if (r === 'crecimiento') return f.nombre.trim() === '' || f.pesoActual === 0;
    return f.nombre.trim() === '' || f.peso === 0;
  }
  function getAnyForm() {
    if (!isEmpty('bawfy')) return { nombre: forms.bawfy.nombre, peso: forms.bawfy.peso, raza: forms.bawfy.raza, edad: forms.bawfy.edad };
    if (!isEmpty('natural')) return { nombre: forms.natural.nombre, peso: forms.natural.peso, raza: forms.natural.raza };
    if (!isEmpty('crecimiento')) return { nombre: forms.crecimiento.nombre, peso: forms.crecimiento.pesoActual, raza: forms.crecimiento.raza };
    if (!isEmpty('equilibrio')) return { nombre: forms.equilibrio.nombre, peso: forms.equilibrio.peso, raza: forms.equilibrio.raza };
    return null;
  }

  function addToCart(qty) {
    var res = state.result;
    if (!res) return;
    var product = findProduct(res.productoRecomendado);
    if (!product || !product.handle) {
      window.location.href = window.routes.cart_url;
      return;
    }
    if (!product.variantId) {
      window.location.href = '/products/' + product.handle;
      return;
    }

    var quantity = parseInt(qty, 10) || 1;

    // URLs con fallback por si window.routes no está disponible
    var routes = window.routes || {};
    var cartAdd = routes.cart_add_url || '/cart/add.js';
    var cartUrl = routes.cart_url || '/cart';

    // Indicador de carga
    var btn = root.querySelector('.btn-confirm');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Agregando...';
    }

    fetch(cartAdd, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: product.variantId, quantity: quantity }] })
    })
      .then(function (response) {
        if (!response.ok) {
          // Shopify devuelve 422 con detalle del error en el body
          return response.json().then(function (data) {
            throw new Error((data && data.description) || ('HTTP ' + response.status));
          }, function () { throw new Error('HTTP ' + response.status); });
        }
        refreshCartCount();
        window.location.href = cartUrl;
      })
      .catch(function (err) {
        console.error('[carnivoro] Error al agregar al carrito:', err && err.message);
        // Fallback: formulario tradicional de Shopify (más compatible)
        try {
          var form = document.createElement('form');
          form.method = 'post';
          form.action = cartAdd;
          form.style.display = 'none';
          var vid = document.createElement('input');
          vid.type = 'hidden';
          vid.name = 'id';
          vid.value = product.variantId;
          var q = document.createElement('input');
          q.type = 'hidden';
          q.name = 'quantity';
          q.value = quantity;
          form.appendChild(vid);
          form.appendChild(q);
          document.body.appendChild(form);
          form.submit();
        } catch (e2) {
          // Último recurso: ir a la página del producto
          window.location.href = '/products/' + product.handle;
        }
      });
  }

  // ===== CONTADOR DE CARRITO EN HEADER =====
  function refreshCartCount() {
    var badge = document.getElementById('header-cart-count');
    if (!badge) return;
    var toggle = document.getElementById('header-cart-toggle');
    var r = getRoutes();
    fetch(r.cartJs, { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var count = (cart && typeof cart.item_count !== 'undefined') ? cart.item_count : 0;
        badge.textContent = count;
        badge.setAttribute('data-count', count);
        badge.classList.remove('bump');
        // forzar reflow para reiniciar animación
        void badge.offsetWidth;
        if (count > 0) badge.classList.add('bump');
        // Mostrar el icono solo si el carrito tiene productos
        if (toggle) toggle.classList.toggle('has-cart', count > 0);
      })
      .catch(function () {});
  }

  // ---- Init ----
  function handleClick(e) {
    if (!root) return;
    if (!root.contains(e.target)) return;
    var recipeBtn = e.target.closest('.recipe-card');
    if (recipeBtn) {
      e.preventDefault();
      selectRecipe(recipeBtn.getAttribute('data-recipe'));
      return;
    }
    var back = e.target.closest('.back-btn');
    if (back) { goBack(); return; }
    var calcBtn = e.target.closest('.btn-calc');
    if (calcBtn) { e.preventDefault(); calcular(); return; }
    var weeklyAdd = e.target.closest('#weekly-add');
    if (weeklyAdd) { state.showWeekly = true; state.weeklyQty = (weeklyRecommendation(state.result) || {}).packagesNeeded || 1; render(); return; }
    var addCart = e.target.closest('#add-cart');
    if (addCart) { state.showQuantity = true; render(); return; }
    var again = e.target.closest('#again, #again2');
    if (again) { state.showResult = false; render(); return; }
    var m = e.target.closest('.qty-btn');
    if (m) {
      var isWeekly = m.id.indexOf('wk-') === 0;
      if (m.id.indexOf('minus') !== -1) { if (isWeekly) { if (state.weeklyQty > 1) state.weeklyQty--; } else { if (state.cartQty > 1) state.cartQty--; } }
      else { if (isWeekly) state.weeklyQty++; else state.cartQty++; }
      render();
      return;
    }
    var confirm = e.target.closest('.btn-confirm');
    if (confirm) { addToCart(state.showWeekly ? state.weeklyQty : state.cartQty); return; }
    var cancel = e.target.closest('.btn-cancel');
    if (cancel) { if (state.showWeekly) state.showWeekly = false; else state.showQuantity = false; render(); return; }
  }

  var clickBound = false;
  function init() {
    // La lógica de carrito se movió a assets/cart.js

    root = document.getElementById('calc-root');
    if (!root) {
      console.error('[carnivoro] No se encontró #calc-root');
      return;
    }
    console.log('[carnivoro] init OK, render iniciado');

    if (!clickBound) {
      document.addEventListener('click', handleClick);
      clickBound = true;
    }

    // Soporte de query param ?receta= para deep-link desde landing
    var params = new URLSearchParams(window.location.search);
    var receta = params.get('receta');
    var validas = ['natural', 'crecimiento', 'equilibrio', 'bawfy'];

    // En vista de producto, la calculadora viene preconfigurada con la receta correspondiente
    var defaultRecipe = null;
    var defEl = document.getElementById('calc-default');
    if (defEl) {
      try {
        var defData = JSON.parse(defEl.textContent || '{}');
        if (defData && defData.recipe) defaultRecipe = defData.recipe;
        if (defData && defData.handle) state.embeddedProduct = defData.handle;
        else if (defData && defData.product) state.embeddedProduct = defData.product;
      } catch (e) {}
    }
    state.embedded = !!defaultRecipe;

    if (defaultRecipe && validas.indexOf(defaultRecipe) !== -1) {
      selectRecipe(defaultRecipe);
    } else if (receta && validas.indexOf(receta) !== -1) {
      selectRecipe(receta);
    } else {
      render();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Respaldo por si el DOM aún no está listo cuando el script corre
  window.addEventListener('load', function () {
    if (!root) init();
  });
})();
